import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center">
                <i className="ri-book-read-line text-2xl text-primary-400"></i>
              </div>
              <span className="font-heading text-xl font-bold text-white">
                43423漫画网
              </span>
            </Link>
            <p className="text-sm text-secondary-300 leading-relaxed">
              专注于下拉式漫画免费在线阅读，提供流畅的上下滑动浏览体验。韩漫下拉式、日漫下拉式等多种类型漫画大全，好看的漫画下拉式在线看。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-white mb-4">
              快速导航
            </h4>
            <ul className="flex flex-col gap-2.5">
              <li>
                <Link to="/" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/all" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors">
                  漫画分类
                </Link>
              </li>
              <li>
                <Link to="/category/korean" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors">
                  韩漫下拉式
                </Link>
              </li>
              <li>
                <Link to="/category/japanese" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors">
                  日漫下拉式
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-white mb-4">
              热门分类
            </h4>
            <ul className="flex flex-col gap-2.5">
              <li>
                <Link to="/category/romance" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors">
                  恋爱漫画
                </Link>
              </li>
              <li>
                <Link to="/category/action" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors">
                  热血漫画
                </Link>
              </li>
              <li>
                <Link to="/category/fantasy" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors">
                  奇幻漫画
                </Link>
              </li>
              <li>
                <Link to="/category/urban" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors">
                  都市漫画
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-white mb-4">
              关于我们
            </h4>
            <ul className="flex flex-col gap-2.5">
              <li>
                <Link to="/about" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors">
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors">
                  联系我们
                </Link>
              </li>
              <li>
                <a href="#" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors" rel="nofollow">
                  用户协议
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors" rel="nofollow">
                  隐私政策
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-secondary-700/40">
        <div className="w-full px-4 md:px-6 py-6">
          <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-secondary-400">
              &copy; 2026 43423漫画网 版权所有 | 下拉式漫画免费在线阅读平台
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-secondary-400 hover:text-primary-400 transition-colors" rel="nofollow">
                免责声明
              </a>
              <a href="#" className="text-xs text-secondary-400 hover:text-primary-400 transition-colors" rel="nofollow">
                版权投诉
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}